import Config from './Config';
import Session from './Session';
import FT from './FeatureToggles';
export const initPendo = () => {
  if (
    !pendo ||
    pendo.isReady() || // pendo is already initialized
    !Session.get('id') ||
    !Session.get('tenant') ||
    !Session.get('appSite') ||
    !Config.get('vpcname') ||
    !(Config.get('pendoEnabled') || FT('pendo-integration'))
  ) {
    return;
  }
  let _appSite = Session.get('appSite') || 'DAAS';
  if (FT('pendo-integration-test') && _appSite === 'DAAS_TEST') {
    _appSite = 'DAAS_EXCLUDED';
  }
  const _prefix = Config.get('vpcname') + '__' + _appSite + '__';
  pendo.initialize({
    visitor: {
      id: _prefix + Session.get('id'),
      sid: localStorage.getItem('daas_session_id'),
    },
    account: {
      id: _prefix + Session.get('tenant'),
    },
  });
};
